import * as React from "react";
import {createElement as h} from "react";
import {cx}       from "emotion";
import {Link}     from "react-router-dom";

import "./product-template-route.scss";

import {cbc}                              from "@Common/react/callback-chain";
import {cs}                               from "@Common/react/chain-services";
import {consumeContext}                   from "@Common/react/context";
import {keyed}                            from "@Common/react/keyed";
import {Load}                             from "@Common/react/load";
import {rLsStore}                         from "@Common/react/ls-store";
import {QueryNumberArray}                 from "@Common/react/query-number-array";
import {UseState}                         from "@Common/react/use-state";
import {isEdge, isIe}                     from "@Common/ui-components/debug/is-ie-edge-or-firefox";
import {ConfirmDialog}                    from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {Responsive}                       from "@Common/ui-components/responsive";
import {flatten1, isEmpty, reverse, sort} from "@Common/utils/collections";
import {chain}                            from "@Common/utils/fs";
import {SubHeader}                        from "@Xpresso/routes/common/sub-header/sub-header";
import {StyleFilter}                      from "../../../common/components/style-filter/style-filter";
import {TemplateListMode}                 from "../../../common/components/template-list-mode/template-list-mode";
import {Layout}                           from "../../../layout/layout";
import {Tooltip}                          from "../../../../common/tool-tip";


const templatesPerLoad = 50;

export const ProductTemplateRoute = ({match}) => cs(
    consumeContext("apis"),
    consumeContext("userCreatedCatSubStyle"),
    consumeContext("routerHistory"),
    ["products", ({userCreatedCatSubStyle}, next) => next(userCreatedCatSubStyle?.value)],
    ["more", (_, next) => UseState({
        initValue: templatesPerLoad,
        next,
    })],
    ["styleTemplates", ({apis}, next) => <Load {...{
        _key: match.params.sub_id,
        fetch: () => apis.next.getStyleTemplate([match.params.sub_id]),
        next,
    }}/>],
    ["filter", (_, next) => h(QueryNumberArray, {
        param: "filter",
        next,
    })],
    ["reversed", (_, next) => UseState({
        next,
    })],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["viewMode", ({responsive}, next) => responsive.lt("md") ? next({value: "large"}) : rLsStore("tiles.viewMode", "medium")({}, next)],
    consumeContext("themeScheme"),
    ({products, styleTemplates, filter, reversed, viewMode, more, routerHistory}) => {
        const cat = products && products[match.params.cat_id];
        const sub = cat && cat.child.find((sub) => sub.id == match.params.sub_id);

        const filteredTemplates = styleTemplates && flatten1(
            Object.keys(styleTemplates)
                .filter((styleId) => isEmpty(filter.value) || filter.value.find((filterStyleId) => filterStyleId == styleId) != null)
                .map((styleId) => styleTemplates[styleId].templates)
        ) || [];
        return (
            <Layout className="product-template-route-23d" active="catSubcatStyle">
                <SubHeader
                    backLink={
                        <a
                            onClick={() => routerHistory.goBack()}
                            className="back"
                            xd-qa-type="link"
                            xd-qa-name="Back"
                        >
                            <i className="fa fa-chevron-left"/> Back
                        </a>
                    }
                    title="Select Product"
                />
                <div className="restrict-width-1">
                    <div className="controls">
                        <StyleFilter {...{
                            items: sub && sub.child.map((style) => {
                                const selected = filter.value && ~filter.value.indexOf(style.id);
                                return ({
                                    label: style.name,
                                    selected,
                                    onClick: () => filter.onChange(!selected ? [
                                        ...filter.value || [],
                                        style.id,
                                    ] : filter.value.filter((i1) => i1 !== style.id)),
                                });
                            }),
                            count: filteredTemplates.length,
                            reversed,
                            onClear: () => filter.onChange(null),
                        }}/>

                        <div className="view-modes">
                            {TemplateListMode(viewMode)}
                        </div>
                    </div>

                    {!products ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Loading">
                            Loading...
                        </div>
                    )  : !cat || !sub ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Empty">
                            No templates are available in this category!
                        </div>
                    ) : <>
                            {rTemplates(
                                chain(
                                    filteredTemplates,
                                    // @ts-ignore
                                    (_) => sort(_, (t) => t.seq),
                                    (_) => reversed.value ? reverse(_) : _,
                                    (_) => _.slice(0, more.value),
                                ),
                                {mode: viewMode.value}
                            )}
                            {more.value < filteredTemplates.length && (
                                <div className="load-more">
                                    <button
                                        onClick={()=> more.change(v=>v+templatesPerLoad)}
                                    >
                                        Load More
                                    </button>
                                </div>
                            )}
                        </>
                    }
                </div>
            </Layout>
        );
    },
);

export const rTemplates = (templates, {mode = "medium", hash = "", clickEvent = (e, id) => {}}) => (
    <div className={cx("templates templates-z6s", mode, {"ie": isIe(), "edge": isEdge()})}>
        {templates.map((template: any) => (
            rTemplateTile({template, hash, clickEvent})
        ))}
    </div>
);

const rTemplateTile = ({template, hash, clickEvent = (e, id) => {}}) => cs(
    keyed(template.id),
    ({}) => (
        <Link
            to={`/manage-templates/private${hash}-${template.id}-new`}
            className="template" xd-qa-type="template"
            onClick={(e) => {
                clickEvent(e, template.id);
            }}
        >
            <Tooltip/>

            <div className="box">
                {template.images[4] && (
                    <img className="image" src={template.images[4].url} alt={template.name.trim()}/>
                )}
            </div>
            {template.product.internalDescription != "Postcard" && template.templatePage === "both" && template.images[5] && (
                <div className="box">
                    <img className="image" src={template.images[5].url} alt={template.name.trim()}/>
                </div>
            )}

            <div className="content">
                <div
                    className="name"
                    data-tip={template.name.trim()}
                >
                    {template.name.trim()}
                </div>
                <div className="hr"/>

                <div
                    className="size1"
                    data-tip={template.product.name.trim()}
                >
                    {template.product.name.trim()}
                </div>
                <div className="size2">
                    {cbc(template.product, [
                        (_, next) => (
                            <table>
                                <tbody>
                                {next(_)}
                                </tbody>
                            </table>
                        ),
                        (p) => <>
                            {p.finishedWidth != 0 && p.finishedHeight != 0 && (
                                <tr data-tip={`Finished Size: ${p.finishedWidth}" x ${p.finishedHeight}"`}>
                                    <td className='right'>Finished Size:</td>
                                    <td>{p.finishedWidth}{`"` }{" x "}{p.finishedHeight}{`"`}</td>
                                </tr>
                            )}

                            {(
                                (p.finishedWidth != 0 && p.finishedHeight != 0) &&
                                (p.flatWidth != p.finishedWidth || p.flatHeight != p.finishedHeight )
                            ) && (
                                <tr data-tip={`Flat Size: ${p.finishedWidth}" x ${p.finishedHeight}"`}>
                                    <td className='right'>Flat Size:</td>
                                    <td>{p.flatWidth}{`"` }{" x "}{p.flatHeight}{`"`}</td>
                                </tr>
                            )}
                        </>,
                    ])}
                </div>
            </div>

            {template.internalUser === true && (
                <div className="template-id-box">
                    {template.id}
                </div>
            )}
        </Link>
    )
);